module.exports = __webpack_public_path__ + "img/connect-illustration.433c433d.png";